import { useGlobalContext } from "../../../../Context/Context";
import Button from "../../../Custom/Button/Button";

const obrazci = [
  "ŠEME EVAKUACIJE I PP. OPTEREĆENJA",
  "PROTIV POŽARNA SREDSTVA I OPREMA",
  "ZOP DOKUMENTACIJA",
  "OBUKA ZAPOSLENIH",
  "UPUTSTVA I OZNAKE",
  "OPASNE MATERIJE"
];

function ShowBarZastitaOdPozara() {
  const { selectedZastitaOdPozara, setSelectedZastitaOdPozara } =
    useGlobalContext();

  const handleClickObrazac = (index) => {
    if (selectedZastitaOdPozara !== index + 1) {
      setSelectedZastitaOdPozara(index + 1);
    } else {
      setSelectedZastitaOdPozara(0);
    }
  };

  return (
    <div style={{ backgroundColor: "white" }}>
      {obrazci.map((obrazac, i) => (
        <div onClick={() => handleClickObrazac(i)}>
          <Button
            active={selectedZastitaOdPozara === i + 1}
            style={{
              padding: "7px",
              fontWeight: "bold",
              textAlign: "left",
              minHeight: "64px",
              display: "block",
              fontSize: "16px"
            }}
          >
            {obrazac}
          </Button>
        </div>
      ))}
    </div>
  );
}

export default ShowBarZastitaOdPozara;
